export const PAYMENT_METHODS = {
    BANK_TRANSFER: {
        value: 'BANK_TRANSFER',
        label: 'Bank Transfer',
    },
    DIRECT_DEBIT: {
        value: 'DIRECT_DEBIT',
        label: 'Direct Debit',
    },
    CARD: {
        value: 'CARD',
        label: 'Credit/Debit Card',
    },
};
